import React from 'react';
import cn from 'classnames';
import AcceptanceName from '../../controllers/AcceptanceName';
import { dateFormats } from '../../shared/packages/dateTime';
import Period from '../../shared/ui/Period';
import styles from './index.module.scss';

const AcceptanceNameAndPeriod = ({ className, fromDate, toDate, name }) => {
  return (
    <div className={cn(styles.root, className)}>
      <AcceptanceName
        className={styles.name}
        value={name}
        mode={AcceptanceName.modes.readable}
      />
      <Period fromDate={formatDate(fromDate)} toDate={formatDate(toDate)} />
    </div>
  );
};

export default AcceptanceNameAndPeriod;

function formatDate(date) {
  return date.format(dateFormats.DMY);
}
